// extracted by mini-css-extract-plugin
export default {"wrapper":"Countdown_wrapper__Ymxw4","finished":"Countdown_finished__+te3t"};